import { Ellipsis } from 'lucide-react';
import axios from 'axios';
import { FilterType } from 'bindings/filters/FilterType';
import { GenericReport, MyFilters } from 'bindings/reports/generic/GenericReport';
import { Granularity } from 'bindings/time/Granularity';
import listWithPenImage from 'images/icon/list_with_pen.svg';
import * as _ from 'lodash';
import * as moment from 'moment';
import * as React from 'react';
import { getTranslate, Translate } from 'react-localize-redux';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { toast } from 'react-toastify';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import type { Granularity as ValidatorGranularity } from 'validators-web';
import * as wasm from 'validators-web';
import { AAdditionalColumns, additionalColumnTypeToFilterTypeAndPath, getAdditionalColumns, getFirstValueNotPieChart } from '../../../atoms/additionalColumns';
import { AAdditionalFieldColumns, fieldTypeToFilterType } from '../../../atoms/additionalFieldColumns';
import { ACalculatedFields, CalculatedField, CalculatedFieldTarget, postCalculatedFields } from '../../../atoms/calculatedFields';
import { ACampaigns } from '../../../atoms/campaignAtom';
import { ACompanies } from '../../../atoms/clientCompany';
import { AAllBrands, ABrandFilter } from '../../../atoms/filter/BrandFiltersAtom';
import { AFormTemplatePicker } from '../../../atoms/filter/formPicker';
import { AFormFields } from '../../../atoms/forms';
import { AInputSearch } from '../../../atoms/filter/InputSearchFilter';
import { AProductFilter } from '../../../atoms/filter/productsFilterAtom';
import { ATagFilter } from '../../../atoms/filter/tagsFilterAtom';
import { ADatePicker, AGranularitySelect, ATimeRangeFilter3, AVariationSelect } from '../../../atoms/filter/timeFilterAtom';
import { AUserPicker } from '../../../atoms/filter/usersFilterAtom';
import { AUsers } from '../../../atoms/global/users';
import { AViews, DbView, deleteView, getViews, NewView, postView, putView, ReportView } from '../../../atoms/global/views';
import { AProducts, Product } from '../../../atoms/product';
import { AtomCategory } from '../../../atoms/utils/model/Model';
import Dropdown from '../../../components_v2/dropdown/Dropdown';
import { DropdownData } from '../../../components_v2/dropdown/model/Model';
import { FilterResult, filterTreeLength } from '../../../components_v2/filter/model/Model';
import { convertFilters, Filter, FilterParameter, FilterParameterParent } from '../../../components_v2/filter/pages/FilterList';
import Input from '../../../components_v2/input/Input';
import InputSearch from '../../../components_v2/input/InputSearch';
import { PopupMode } from '../../../components_v2/popup/model/Model';
import Popup from '../../../components_v2/popup/Popup';
import PopupDeletion from '../../../components_v2/popup/PopupDeletion';
import BrandFilter from '../../../components_v2/toolbarFilter/brands/BrandFilter';
import FormTemplateTemplatePicker from '../../../components_v2/toolbarFilter/forms/FormTemplatePicker';
import ProductPerCategoryFilter from '../../../components_v2/toolbarFilter/products/productPerCategoryFilter';
import { TagType } from '../../../components_v2/toolbarFilter/tags/Model';
import TagFilter from '../../../components_v2/toolbarFilter/tags/tagFilter';
import GranularitySelect from '../../../components_v2/toolbarFilter/time/GranularitySelect';
import TimeRangeFilter3, { TimeRange3ToDate } from '../../../components_v2/toolbarFilter/time/TimeRangeFilter3';
import VariationSelect from '../../../components_v2/toolbarFilter/time/VariationSelect';
import ToolbarFilter, { ToolbarElement, ToolbarFilterElement } from '../../../components_v2/toolbarFilter/ToolbarFilter';
import UserPicker from '../../../components_v2/toolbarFilter/users/userPicker';
import { dateToNaiveDateTime, isSuperAdmin, momentToNaiveDateTime, useWindowDimensions } from '../../../components_v2/utils';
import PopupView, { ViewCreation } from '../../../components_v2/view/PopupView';
import ViewPicker from '../../../components_v2/view/ViewPicker';
import storeLang from '../../../helpers/storeLang';
import RefreshButton from '../../../myToolbar/RefreshButton';
import { DefaultButton } from '../../../styles/global/css/GlobalButton';
import { GreySidely3 } from '../../../styles/global/css/Utils';
import { translateToString } from '../../../styles/global/translate';
import { useFunctionState } from '../../../utils/customHooks';
import { AlertContext, AlertRes } from '../../alert/AlertProvider';
import { getCompanyFilters } from '../../client-companies/data/action';
import { SidebarButton } from '../../client-companies/style/Style';
import { Dashboard, getDashboards } from '../../dashboard/action';
import { CreateChartPopup } from '../../dashboard/Dashboard';
import { ToolbarImageContainer, TOOLBARS_HEIGHT } from '../../globals/defaultToolbar/style/Style';
import { ToolbarState } from '../../globals/mainPage/mainPage';
import { LoadingStateEnum } from '../../import/model';
import { failExportRunningToast, launchExportRunningToast } from '../../../components/toolbar/WebSocketListener';
import { ComponentLoader } from '../../map/modalRight/ModalCalendar';
import NoData from '../../noData/NoData';
import PermissionContext from '../../permissions/PermissionContext';
import usePermission from '../../permissions/usePermission';
import { ModalState } from '../../products/model';
import { FlexDiv } from '../../products/style';
import { syncTagsAndStatuses } from '../../settings/subSettings/actions';
import { getReportById, Report as ReportInfo, ReportValue } from '../action';
import { Report, Row } from '../interpretor/bareReportingDecoder';
import ReportInterpretorContext, { ReportInterpretorProvider, ReportInterpretorProviderProps } from '../interpretor/hoverContext';
import { ReportInterpretorNoProvider, valueToString } from '../interpretor/ReportInterpretor';
import { isFilterableProductField, matchProductFields, ProductFieldFilter, ProductFieldFilters, ProductFieldValues, useProductFieldValues } from './productFieldFilter';
import { columnDisplayOptionsOf } from './columnColors';
import { reportingAction, reportingState } from '../Reducer';
import { createGenericReport, createNewAdditionalColumn, deleteGenericReport, exportGenericReportServer, getExternalDatasets, getGenericAndDecodeReport, getGenericReport, getGoals, getReportPresignedUrl, Goal, GoalEvolutionCalculus, GoalHashMap, updateGenericReport } from './action';
import { PopupExportReport } from './export';
import { AllPeriods } from './genericEditor';
import importGoals from './import';
import { setLocalReport } from './localReport';

export function filterProducts(tags: (string)[], products: Product[]): Product[] {
	return products.filter(product => {
		let result = product.tags.includes(+tags[0]);
		for (let i = 1; i < tags.length; i += 2) {
			const condition = tags[i];
			const tag = +tags[i + 1];
			if (condition === 'and') {
				result = result && product.tags.includes(tag);
			} else if (condition === 'or') {
				result = result || product.tags.includes(tag);
			}
		}
		return result;
	});
}

type PostCalculatedField = Omit<CalculatedField, 'id'>

type GenericProps = {
	state: reportingState
	reprasentation: ReportValue,
	dispatch: (action: reportingAction) => void
	setToolBarState: (value: ToolbarState) => void
	updateGenericReports: () => Promise<void>
};

export type goalsProps = {
	reportId: number,
	isEvolutionsReport: boolean,
	isGoals: boolean,
	setIsGoals: (value: React.SetStateAction<boolean>) => void,
	goals: Goal[] | undefined,
	emptyGoalInterpretation: string | undefined,
	setEmptyGoalInterpretation: (value: React.SetStateAction<string | undefined>) => void,
	evolutionCalculus: GoalEvolutionCalculus,
	setEvolutionCalculus: (value: React.SetStateAction<GoalEvolutionCalculus>) => void,
	setGoalHashMap: React.Dispatch<React.SetStateAction<GoalHashMap>>
	setSelectedPanel: React.Dispatch<React.SetStateAction<number>>,
	setShowDelta: (value: React.SetStateAction<boolean>) => void,
	showDelta: boolean
	setWeightByRef: (value: React.SetStateAction<boolean>) => void,
	weightByRef: boolean,
	hasPercentages: boolean
}

export type LocalFilters = {
	[key: string]: unknown
} & { my_filters?: MyFilters, filter: FilterResult };

type jsx = { name: string, child: JSX.Element };

// Un rapport sur un jeu de données externe (ClickHouse) suit les options
// normales du rapport (fenêtre, variation) mais pas les filtres formulaire
export function isExternalGenericReport(report: GenericReport): boolean {
	return report?.panels?.some(p => p.columns?.some(c => c && typeof c === 'object' && ('External' in c || 'ExternalDimension' in c))) ?? false;
}

export function initFilters(report: GenericReport): { filters: LocalFilters, right_jsx: jsx[], form_jsx: jsx[], product_jsx: jsx[] } {
	const localfilters: LocalFilters = {
		variation: report.evolution || report.sum ? undefined : report.variation,
		evolution: report.evolution,
		form_filter: report.form_filter,
		created_by_filter: report.created_by_filter,
		product_filter: report.product_filter,
		filter: report.filter,
		my_filters: report.my_filters,
		external: isExternalGenericReport(report)
	};


	return {
		filters: localfilters, right_jsx: [
			{
				name: translateToString(report.evolution ? 'analysis_granularity' : 'analysis_variation'),
				child: report.evolution ? <GranularitySelect fullScreen context /> : <VariationSelect fullScreen context />,
			},
			{
				name: translateToString('forms_taken_into_account'),
				child: <TimeRangeFilter3 context fullScreen />
			}
		],
		form_jsx: [
			{
				name: translateToString('form_creator'),
				child: <UserPicker logo={listWithPenImage} atomId={0} deleted={false} context permission={'ViewReporting'} fullScreen />
			},
			{
				name: translateToString('form_template'),
				child: <FormTemplateTemplatePicker context fullScreen />
			},
		],
		product_jsx: [
			{
				name: translateToString('product_categories'),
				child: <ProductPerCategoryFilter context atomId={0} fullScreen />
			},
			{
				name: translateToString('brands'),
				child: <BrandFilter context fullScreen />
			},
			{
				name: translateToString('products_tags'),
				child: <TagFilter fullScreen context atomId={0} tagType={'product'} />
			}

		]
	};
}

export const ReportFiltersContext = React.createContext<{
	filters: LocalFilters
	reportFilters: LocalFilters
	setFilters: React.Dispatch<React.SetStateAction<LocalFilters>>
	jsxFilters: jsx[][]
}>({ filters: {} as LocalFilters, reportFilters: {} as LocalFilters, setFilters: () => undefined, jsxFilters: [] });

export function ReportFiltersProvider(props: { genericReport: GenericReport, children: React.ReactNode }) {
	const [filters, setFilters] = React.useState<LocalFilters>({});
	const [reportFilters, setReportFilters] = React.useState<LocalFilters>({});
	const [jsxFilters, setJsxFilters] = React.useState<jsx[][]>([]);
	const [init, setInit] = React.useState(false);
	React.useEffect(() => {
		const { filters, right_jsx, form_jsx, product_jsx } = initFilters(props.genericReport);
		setFilters(filters);
		setReportFilters(filters);
		setJsxFilters([right_jsx, form_jsx, product_jsx]);
		setInit(true);
	}, [props.genericReport]);

	return (
		<ReportFiltersContext.Provider value={{ filters, reportFilters, setFilters, jsxFilters }}>
			{init && props.children}
		</ReportFiltersContext.Provider>
	);
}

export default function Generic(props: GenericProps & ReportInterpretorProviderProps) {
	return <ReportFiltersProvider genericReport={props.reprasentation}>
		<ReportInterpretorProvider onCompanyClick={props.onCompanyClick} onFormInstanceClick={props.onFormInstanceClick}>
			<_Generic {...props} />
		</ReportInterpretorProvider>
	</ReportFiltersProvider>;
}

function launchToast(message: string, timing?: number) {
	toast.info(message, {
		position: 'top-right',
		autoClose: timing ?? 3000,
		hideProgressBar: false,
		closeOnClick: true,
		pauseOnHover: true,
		draggable: true,
		progress: undefined
	});
}

export function NewReport(props: { onBreak: () => void, onOk: () => void, categoryId?: number }) {
	const [name, setName] = React.useState<string>('');
	const history = useHistory();
	return <>
		<Input name='' value={name} type='text' onChange={setName} label={translateToString('name')} />
		<DefaultButton
			margin='0'
			onClick={() => {
				props.onOk();
				createGenericReport({
					'name': name,
					'value': {
						'group_by': 'Company',
						'panels': [
							{ 'columns': [] }
						]
					},
					'report_group_id': props.categoryId ?? 0
				}).then(res => {
					getGenericReport(res).then(report => {
						setLocalReport({
							id: report.id,
							name: report.name,
							report: report.value
						});
						history.push({ pathname: 'reportEditor' });
					});
				}
				);
			}}
			disabled={!name}>
			<Translate id='next' />
		</DefaultButton>
	</>;
}

// The uuid sent when the filters leave no product: an empty list would mean
// no filter at all, i.e. every product
const NO_PRODUCT = '00000000-0000-0000-0000-000000000000';

// `fieldValues`: the values of the product custom fields the filters name
// (see productFieldFilter.tsx), loaded by the caller
export function getFinalyFilteredProducts(filters: LocalFilters, products: Product[], fieldValues?: ProductFieldValues) {
	let finaly: Product[] | undefined = undefined;
	if (JSON.stringify(filters) !== '{}') {
		if (filters.my_filters && filters.my_filters.tags !== undefined && filters.my_filters.tags.length != 0) {
			finaly = filterProducts(filters.my_filters.tags, products);
		}
		if (filters.my_filters && filters.my_filters.brands && !filters.my_filters.brands.all) {
			if (finaly) {
				finaly = finaly.filter(e => filters.my_filters?.brands?.brands?.some(b => b == e.brand));
			} else {
				finaly = products.filter(e => filters.my_filters?.brands?.brands?.some(b => b == e.brand));
			}
		}
		if (filters.my_filters?.products && !filters.my_filters?.products?.all) {
			if (finaly) {
				finaly = finaly.filter(e => filters.my_filters?.products?.products.some(p => p == e.id));
			} else {
				finaly = products.filter(e => filters.my_filters?.products?.products?.some(p => p == e.id));
			}
		}
		const productFields: ProductFieldFilters | undefined = filters.my_filters?.product_fields;
		if (productFields && Object.keys(productFields).length > 0) {
			finaly = (finaly ?? products).filter(e => matchProductFields(e.uuid, productFields, fieldValues ?? new Map()));
		}
		if (finaly?.length === 0) return [NO_PRODUCT];
		return finaly?.map(e => e.uuid);
	}
}

function periodToDate(period: string, begin: boolean): moment.Moment {
	if (begin) {
		switch (period) {
			case 'Today': return moment().startOf('day');
			case 'ThisWeek': return moment().startOf('week');
			case '7DaysAgo': return moment().subtract(7, 'days').startOf('day');
			case 'LastWeek': return moment().subtract(1, 'week').startOf('week');
			case 'ThisMonth': return moment().startOf('month');
			case '30DaysAgo': return moment().subtract(30, 'days').startOf('day');
			case 'LastMonth': return moment().subtract(1, 'month').startOf('month');
			case '90DaysAgo': return moment().subtract(90, 'days').startOf('day');
			case 'ThisYear': return moment().startOf('year');
			case '365DaysAgo': return moment().subtract(365, 'days').startOf('day');
			case 'LastYear': return moment().subtract(1, 'year').startOf('year');
			default: return moment().startOf('day');
		}
	} else {
		switch (period) {
			case 'Today': return moment().endOf('day');
			case 'ThisWeek': return moment().endOf('week');
			case '7DaysAgo': return moment().subtract(7, 'days').endOf('day');
			case 'LastWeek': return moment().subtract(1, 'week').endOf('week');
			case 'ThisMonth': return moment().endOf('month');
			case '30DaysAgo': return moment().subtract(30, 'days').endOf('day');
			case 'LastMonth': return moment().subtract(1, 'month').endOf('month');
			case '90DaysAgo': return moment().subtract(90, 'days').endOf('day');
			case 'ThisYear': return moment().endOf('year');
			case '365DaysAgo': return moment().subtract(365, 'days').endOf('day');
			case 'LastYear': return moment().subtract(1, 'year').endOf('year');
			default: return moment().endOf('day');
		}
	}

}

function _Generic(props: GenericProps) {
	const reduxDispatch = useDispatch();
	const [report, setReport] = React.useState<Report>();
	// bumped on every full query; lazy subtree splices keep it, so the table
	// (keyed on it) keeps its expansion state during expansion only
	const [reportGeneration, setReportGeneration] = React.useState(0);
	// server-provided refusal reason (e.g. too many rows), shown over the
	// generic loading error when present
	const [errorMessage, setErrorMessage] = React.useState<string>();
	const [reportInfos, setReportInfos] = React.useState<ReportInfo>();
	const [loadingState, setLoadingState] = React.useState<LoadingStateEnum>();
	const subComponentToolBarRef = React.useRef<ToolbarState>();
	const [subComponentToolBarVersion, setSubComponentToolBarVersion] = React.useState(0);
	const setSubComponentToolBarState = React.useCallback((state: ToolbarState) => {
		subComponentToolBarRef.current = state;
		setSubComponentToolBarVersion(v => v + 1);
	}, []);
	const translate = getTranslate(storeLang.getState().localize);
	const { height, width } = useWindowDimensions();
	const [pickedDates, setPickedDates] = useRecoilState(ADatePicker);
	const [filteredProducts, setFilteredProducts] = useRecoilState(AProductFilter);
	const granularity = useRecoilValue(AGranularitySelect);
	const [user, setUser] = useRecoilState(AUserPicker(0));
	const [filterParams, setFilterParams] = React.useState<FilterParameter[] | FilterParameterParent[]>();
	const { filters, reportFilters, setFilters } = React.useContext(ReportFiltersContext);
	const products = useRecoilValue(AProducts);
	const productFieldValues = useProductFieldValues(filters.my_filters);
	const formFields = useRecoilValue(AFormFields);
	const productFields = React.useMemo(() => formFields.filter(isFilterableProductField), [formFields]);
	const companies = useRecoilValue(ACompanies);
	const campaigns = useRecoilValue(ACampaigns);
	const [brandFilter, setBrandFilter] = useRecoilState(ABrandFilter);
	const [tagsFilter, setTagsFilter] = useRecoilState(ATagFilter);
	const [allBrands, setAllBrands] = useRecoilState(AAllBrands);
	const [inputSearchText, setInputSearchText] = useRecoilState(AInputSearch);
	const [finalyFilteredProducts, setFinalyFilteredProducts] = React.useState<{ setted: boolean, value: string[] | undefined }>({ setted: false, value: undefined });
	const variation = useRecoilValue(AVariationSelect);
	const owners = useRecoilValue(AUsers);
	const pickedRange = useRecoilValue(ATimeRangeFilter3);
	const setDataState = useSetRecoilState(AAdditionalColumns);
	const formTemplateTemplate = useRecoilValue(AFormTemplatePicker);
	const refresh = async() => {
		const data = await getAdditionalColumns();
		setDataState(data);
	};
	const history = useHistory();

	// Views
	const [views, setViews] = useRecoilState(AViews);
	const [isViewOpen, setIsViewOpen] = React.useState<boolean>(false);
	const [selectedView, setSelectedView] = useFunctionState<DbView<ReportView> | undefined>(views.reports?.find(v => v.id.toString() === localStorage.getItem('reports_view_id-' + props.state.data.id)),
		({ newValue }) => {
			if (newValue) {
				localStorage.setItem('reports_view_id-' + props.state.data.id, newValue.id.toString());
			} else {
				localStorage.removeItem('reports_view_id-' + props.state.data.id);
			}
			return newValue;
		}
	);
	const [editedView, setEditedView] = React.useState<DbView<ReportView> | undefined>();

	const additionalColumns = useRecoilValue(AAdditionalColumns);
	const additionalFieldColumns = useRecoilValue(AAdditionalFieldColumns);
	const { isAllowedTo } = React.useContext(PermissionContext);
	const { evolutionStateRef } = React.useContext(ReportInterpretorContext);

	const [isDateFuckedUp, setIsDateFuckedUp] = React.useState(false);
	const [companyFilterParameterParent, setCompanyFilterParameterParent] = React.useState<FilterParameterParent>();
	const [deletionModalState, setDeletionModalState] = React.useState<ModalState<DbView<ReportView>>>({ isOpen: false });
	const setCalcFieldAtom = useSetRecoilState(ACalculatedFields);
	const calculatedFields = useRecoilValue(ACalculatedFields);
	const [isGoals, setIsGoals] = React.useState(false);
	const [goals, setGoals] = React.useState<Goal[] | undefined>(undefined);
	const [goalHashMap, setGoalHashMap] = React.useState<GoalHashMap | undefined>(undefined);
	const [selectedPanel, setSelectedPanel] = React.useState<number>(0);
	const [emptyGoalInterpretation, setEmptyGoalInterpretation] = React.useState<string>('0');
	const [evolutionCalculus, setEvolutionCalculus] = React.useState<GoalEvolutionCalculus>(reportInfos?.goals_options?.evolution_calculus ?? GoalEvolutionCalculus.Default);
	const [showDelta, setShowDelta] = React.useState<boolean>(reportInfos?.goals_options?.show_delta ?? false);
	const [weightByRef, setWeightByRef] = React.useState<boolean>(reportInfos?.goals_options?.weight_by_ref ?? false);
	const isEvolutionReport = reportInfos && reportInfos.value && 'evolution' in reportInfos.value;
	const hasPercentages = React.useMemo(() => {
		const rowHasPercentage = (row: Row): boolean => row.cells.some(c => c.value.tag === 0) || row.rows.some(rowHasPercentage);
		return report?.panels[selectedPanel]?.rows.some(rowHasPercentage) ?? false;
	}, [report, selectedPanel]);
	const [isReportExportOpen, setIsReportExportOpen] = React.useState<boolean>(false);
	const [isCreateChartPopupOpen, setIsCreateChartPopupOpen] = React.useState<boolean>(false);
	const [dashboards, setDashboards] = React.useState<Dashboard[]>([]);

	// DO NOT REMOVE THIS OR THE APP WILL CRASH
	// eslint-disable-next-line @typescript-eslint/no-unused-expressions -- see above
	() => console.log(wasm);

	React.useEffect(() => {
		getViews().then(newViews => {
			setSelectedView(views.reports?.find(v => v.id.toString() === localStorage.getItem('reports_view_id-' + props.state.data.id)));
			setAllBrands(true);
			setBrandFilter(undefined);
			setTagsFilter(undefined);
			setUser(undefined);
			setFilteredProducts(undefined);
			setViews(newViews);
		});
		getDashboards().then(dashboards => {
			setDashboards(dashboards);
		});
	}, []);

	React.useEffect(() => {
		setSelectedView(views.reports?.find(v => v.id.toString() === localStorage.getItem('reports_view_id-' + props.state.data.id)));
		// each bound resolves on its own — a preset through periodToDate, a
		// literal date through moment: routing both through whichever branch
		// `begin` fell into turned a fixed start with an "Aujourd'hui" end
		// into moment('Today'), an Invalid date the report cannot load with
		const rangeBound = (value: string | undefined, begin: boolean): moment.Moment => {
			if (!value) return begin ? moment().subtract(3, 'month').startOf('day') : moment().endOf('day');
			if (AllPeriods.includes(value)) return periodToDate(value, begin);
			return moment(value);
		};
		setPickedDates([rangeBound(props.reprasentation.range?.begin, true), rangeBound(props.reprasentation.range?.end, false)]);
		setFinalyFilteredProducts({ setted: false, value: undefined });
		setLoadingState(undefined);
		getReportById(props.state.data.id).then(res => setReportInfos(res));
	}, [props.state.data?.id]);

	const fetchGoals = () => getGoals(props.state.data.id).then((res) => {
		setGoals(res);
		if (res.length > 0)
			setIsGoals(true);
		else
			setIsGoals(false);
	});

	React.useEffect(() => {
		if (isEvolutionReport) {
			setLoadingState(undefined);
			fetchGoals();
		}
		else
			setIsGoals(false);
	}, [isEvolutionReport, props.state.data.id]);

	React.useEffect(() => {
		setLoadingState(undefined);
	}, [evolutionCalculus, showDelta, weightByRef]);

	React.useEffect(() => {
		setEvolutionCalculus(reportInfos?.goals_options?.evolution_calculus ?? GoalEvolutionCalculus.Default);
	}, [reportInfos?.goals_options?.evolution_calculus]);

	React.useEffect(() => {
		setShowDelta(reportInfos?.goals_options?.show_delta ?? false);
	}, [reportInfos?.goals_options?.show_delta]);

	React.useEffect(() => {
		setWeightByRef(reportInfos?.goals_options?.weight_by_ref ?? false);
	}, [reportInfos?.goals_options?.weight_by_ref]);

	React.useEffect(() => {
		getCompanyFilters().then(async response => {
			const allFirstValues = await getFirstValueNotPieChart();
			const firstValues = allFirstValues.filter(fv => fv.column_type === 'additional_column');
			const newFilterParams = [...response.filters];
			if (isAllowedTo({ objectAction: 'ReadForm' })) {
				newFilterParams.push(
					additionalColumns.reduce((acc: FilterParameter, x) => {
						let type: FilterType;
						let path: string | undefined = undefined;
						if (x.type === 'ReportColumn') {
							const firstValue = firstValues.find(fv => fv.id === x.id);
							if (!firstValue || !firstValue.value) {
								type = 'nullable';
							} else if ('int' in firstValue.value || 'float' in firstValue.value) {
								type = 'numeric';
							} else if ('percentage' in firstValue.value || 'evolution' in firstValue.value) {
								type = 'percentage';
							} else if ('key' in firstValue.value || 'text' in firstValue.value) {
								type = 'string';
							} else {
								type = additionalColumnTypeToFilterTypeAndPath(x.type).type;
							}
							if (firstValue && firstValue.value) {
								path = Object.keys(firstValue.value)[0];
							}
						} else {
							const { type: type_, path: path_ } = additionalColumnTypeToFilterTypeAndPath(x.type);
							type = type_;
							path = path_;
						}
						acc.filters.push({
							id: { additional_columns: [{ id: x.id, path }] },
							name: x.name,
							type
						});
						return acc;
					}, { category: translateToString('additional_columns'), filters: [] })
				);
				newFilterParams.push(
					additionalFieldColumns.reduce((acc: FilterParameter, x) => {
						acc.filters.push({
							id: { additional_field_columns: [x.field_id] },
							name: x.field_name,
							type: fieldTypeToFilterType(x.field_type)
						});
						return acc;
					}, { category: translateToString('additional_field_columns'), filters: [] }));
			}
			const filterNb = filters.filter?.formatted ? filterTreeLength(filters.filter.formatted) : 0;
			const companyFilterParameterParent = { name: translateToString('global.filter.company_filters'), children: newFilterParams, nbFiltersSet: filterNb };
			setCompanyFilterParameterParent(companyFilterParameterParent);
		});
	}, [filters.filter]);

	function checkFilterSet(name: string, filters: LocalFilters): boolean {
		let isSet = false;
		let filterValue: unknown;
		switch (name) {
			case translateToString('form_template'):
				filterValue = filters.form_filter;
				isSet = (filterValue !== undefined && filterValue !== null && (filterValue as number[]).length > 0);
				break;
			case translateToString('form_creator'):
				filterValue = filters.created_by_filter;
				isSet = (filterValue !== undefined && filterValue !== null && (filterValue as number[]).length != owners.length);
				break;
			case translateToString('product_categories'):
				filterValue = filters.product_filter;
				isSet = filters.my_filters?.products ? !filters.my_filters.products?.all :
					(filterValue !== undefined && filterValue !== null && (filterValue as number[]).length > 0);
				break;
			case translateToString('brands'):
				filterValue = filters.my_filters?.brands;
				isSet = (filterValue !== undefined && filterValue !== null && !filters.my_filters?.brands?.all);
				break;
			case translateToString('products_tags'):
				filterValue = filters.my_filters?.tags;
				isSet = (filterValue !== undefined && filterValue !== null && (filterValue as number[]).length > 0);
				break;
		}
		return isSet;
	}

	React.useEffect(() => {
		const res = companyFilterParameterParent ? [companyFilterParameterParent] : [];
		const params = [...res, {
			name: translateToString('products_filters'),
			children: [
				{
					category: translateToString('products_filters'),
					filters: initFilters(props.reprasentation).product_jsx.map(e => {
						return {
							id: e.name,
							name: e.name,
							type: 'nullable',
							jsx: e.child,
							isFilterSet: checkFilterSet(e.name, filters)
						};
					}).concat(productFields.map(field => ({
						id: `product_field_${field.id}`,
						name: field.name,
						type: 'nullable',
						jsx: <ProductFieldFilter field={field} fullScreen />,
						isFilterSet: filters.my_filters?.product_fields?.[field.id] !== undefined
					}))),
				}
			]
		}];
		// les filtres formulaire n'ont pas de sens sur un jeu de données
		// externe: ne montrer que ce qui s'applique vraiment
		if (!isExternalGenericReport(props.reprasentation)) {
			params.push({
				name: translateToString('forms_filters'), children: [
					{
						category: translateToString('forms_filters'),
						filters: initFilters(props.reprasentation).form_jsx.map(e => {
							return {
								id: e.name,
								name: e.name,
								type: 'nullable',
								jsx: e.child,
								isFilterSet: checkFilterSet(e.name, filters)
							};
						})
					}
				]
			});
		}
		setFilterParams(params);
	}, [props.reprasentation, companyFilterParameterParent, filters, productFields]);

	const DEFAULT_FILTER_RESULT: FilterResult = {
		values: {
			array: [],
			combinator: 'and'
		},
		formatted: undefined
	};

	const deleteLocalView = (view: DbView<ReportView>) => {
		if (view) {
			setDeletionModalState({ isOpen: true, data: view });
		}
	};

	const saveView = async(v: ViewCreation) => {
		const data: NewView<'reports'> = {
			data: {
				filters: filters.filter ?? DEFAULT_FILTER_RESULT,
				columns: [],
				name: v.name,
				type: 'reports',
				tagsFilter: tagsFilter,
				brandFilter: brandFilter,
				newFilters: filters,
				filteredProducts: filteredProducts,
				reportId: props.state.data ? props.state.data.id : 0,
				users: user,
				allBrands
			},
			public: v.public
		};
		await (v.id ? putView(v.id, data) : postView(data));
		getViews().then(newViews => {
			setSelectedView(newViews.reports.find(nv => v.id === nv.id || !views.reports.find(v => v.id == nv.id)));
			setViews(newViews);
		});
	};

	const list: DropdownData[] = [];
	list.push(
		{ label: translate('reports.export_report').toString(), value: 4 },
		{ label: translate('reports.share_report').toString(), value: 6 }
	);

	if (usePermission({ objectAction: 'CreateDashboard' }) || isSuperAdmin()) {
		list.push(
			{ label: translate('reports.duplicate_report').toString(), value: 2 },
			{ label: translate('reports.create_report').toString(), value: 3 },
		);
	}

	if (usePermission({ objectAction: 'UpdateDashboard' }) || isSuperAdmin()) {
		list.push(
			{ label: translate('reports.edit_report').toString(), value: 1 },
		);
		if (isEvolutionReport) {
			list.push(
				{ label: translate('import.goals.import').toString(), value: 7 }
			);
		}
	}


	if (usePermission({ objectAction: 'DeleteDashboard' }) || isSuperAdmin()) {
		list.push({ label: translate('reports.delete_report').toString(), value: 5 });
	}

	if (usePermission({ objectAction: 'CreateDashboard' }) || isSuperAdmin()) {
		list.push({ label: translate('dashboard.create_chart_from_report').toString(), value: 8 });
	}


	const { alertDelete, alert } = React.useContext(AlertContext);

	React.useEffect(() => {
		if (filters.my_filters?.timerange && pickedDates && pickedDates[0]) {
			const thirdDate = TimeRange3ToDate(filters.my_filters.timerange, pickedDates[0].toDate());
			setIsDateFuckedUp(filters.my_filters.timerange != undefined && thirdDate !== undefined && (!pickedDates || moment(thirdDate).isAfter(pickedDates[0])));
		} else {
			setIsDateFuckedUp(false);
		}
	}, [filters.my_filters?.timerange, pickedDates]);

	React.useEffect(() => {
		props.setToolBarState({
			title: translate('report.title').toString(),
			bottomLeftToolbarComponent: <FlexDiv gap='10px'>
				<InputSearch
					name={'report_input_search'}
					type={'text'}
					onChange={(value: string) => setInputSearchText(value)}
					value={inputSearchText}
					delay={500}
					placeholder={translateToString('search')}
				/>
				<ViewPicker
					type='reports'
					noBorder
					selectedView={selectedView}
					views={views.reports.filter(v => v.data.reportId === props.state.data?.id)}
					onCreate={() => { setSelectedView(undefined); setIsViewOpen(true); }}
					onDelete={deleteLocalView}
					onEdit={() => setIsViewOpen(true)}
					setEditedView={setEditedView}
					onViewChange={view => {
						setSelectedView(view);
						if (view) {
							// set filters according to view
							setTagsFilter(view.data.tagsFilter);
							setBrandFilter(view.data.brandFilter);
							setFilteredProducts(view.data.filteredProducts);
							setAllBrands(view.data.allBrands ?? true);
							setUser(view.data.users);
							let combinedFilters = view.data.filters.values;
							const reportFiltersCopy = _.cloneDeep(reportFilters);
							if (view.data.filters.values.array.length > 0 && reportFiltersCopy.filter?.values.array.length > 0) {
								combinedFilters = {
									array: [
										...(view.data.filters.values.array ?? []),
										...(reportFiltersCopy.filter?.values.array ?? [])
									],
									combinator: 'and'
								};
							}
							else if (reportFiltersCopy.filter?.values.array.length > 0) {
								combinedFilters = reportFiltersCopy.filter?.values;
							}
							setFilters({ ...view.data.newFilters, filter: { values: combinedFilters, formatted: convertFilters(combinedFilters) } });
						} else {
							// set default view
							setUser([owners.map(e => e.id), false, true]);
							setAllBrands(true);
							setBrandFilter(undefined);
							setTagsFilter(undefined);
							setFilters(initFilters(props.reprasentation).filters);
							setFilteredProducts(undefined);
						}
						setLoadingState(undefined);
					}}
				/>
				{(filters.filter?.formatted || (filters.form_filter) || (filters.created_by_filter) || (tagsFilter && tagsFilter?.length > 0) || !allBrands || !user?.[2] || (filteredProducts && !filteredProducts?.all)) &&
					<SidebarButton
						onClick={() => { setIsViewOpen(true); }}><Translate id='save_view' /></SidebarButton>}
				<ToolbarFilter
					permission='ViewReporting'
					maxWidth={width - 550}
					category={AtomCategory.REPORTS}
					elements={[
						{
							kind: ToolbarElement.DATE_PICKER,
							future: true,
							defaultStart: (pickedDates && pickedDates[0]) ? pickedDates[0] : undefined,
							defaultEnd: (pickedDates && pickedDates[1]) ? pickedDates[1] : undefined,
						},
						{
							kind: ToolbarElement.USER_PICKER,
							logo: listWithPenImage,
							hidden: true,
						},
					].filter(e => e) as ToolbarFilterElement[]}
				/>
				{subComponentToolBarRef.current?.bottomLeftToolbarComponent}
				<RefreshButton onFilter={() => setLoadingState(undefined)} isLoading={loadingState == LoadingStateEnum.LOADING} disabled={!user || user[0].length == 0 || (finalyFilteredProducts.value && finalyFilteredProducts.value.length == 0) || isDateFuckedUp} />
			</FlexDiv>,
			bottomRightToolbarComponent: <>
				{subComponentToolBarRef.current?.bottomRightToolbarComponent ?? <></>}
				{
					<>
						<Dropdown
							datalist={list}
							name='dropdown_actions'
							readOnly
							searchable={false}
							JSXButton={() => (
								<ToolbarImageContainer marginTop='-3px'><Ellipsis color={GreySidely3} strokeWidth={2.5} size={18} /></ToolbarImageContainer>
							)}
							dropdownStyle={{
								optionWidth: '200px',
								optionLeft: '-175px',
								optionHeight: '300px'
							}}
							onChange={(value: DropdownData) => {
								if (!props.state.data) return;
								const data = props.state.data;
								if (value.value === 1) {
									getGenericReport(data.id).then(report => {
										setLocalReport({
											id: report.id,
											name: report.name,
											report: report.value
										});
										history.push({ pathname: 'reportEditor' });
									});
								}
								else if (value.value === 2 && report) {
									alert({
										title: 'Nommer le rapport dupliqué',
										content: (onBreak, onOk) => <DuplicateReport oldReport={data} onBreak={onBreak} onOk={onOk} categoryId={reportInfos?.report_group_id} />,
										noButtons: true,
									});
								}
								else if (value.value === 3) {
									alert({
										title: 'Nommez le nouveau rapport',
										content: (onBreak, onOk) => <NewReport onBreak={onBreak} onOk={onOk} />,
										noButtons: true,
									});
								} else if (value.value == 4 && report) {
									setIsReportExportOpen(true);
								}
								else if (value.value === 5) {
									alertDelete({
										name: 'ce rapport ( ' + data.name + ' )'
									}).then(res => {
										if (res.res === AlertRes.Ok) {
											deleteGenericReport(data.id).then(
												() => props.updateGenericReports()
											);
										}
									});
								} else if (value.value === 6 && (pickedDates != null) && pickedDates[0] && pickedDates[1]) {
									getReportPresignedUrl({
										...props.reprasentation,
										...filters,
										range: { begin: momentToNaiveDateTime(pickedDates[0]), end: momentToNaiveDateTime(pickedDates[1]) },
										product_filter: getFinalyFilteredProducts(filters, products, productFieldValues),
										filter: filters.filter?.formatted,
										window: pickedDates && pickedDates[0] && (props.reprasentation.variation || props.reprasentation.evolution || !props.reprasentation.sum || isExternalGenericReport(props.reprasentation)) && pickedRange != 'thisperiod' ? dateToNaiveDateTime(TimeRange3ToDate(pickedRange, pickedDates[0].toDate())!) : undefined
									}).then(hash => {
										const title = encodeURIComponent(data.name);
										const link = `${window.location.origin}/report-view#${hash}?title=${title}`;
										navigator.clipboard.writeText(link);
										launchToast(translateToString('reports.copied_link'));
									});
								} else if (value.value === 7 && isEvolutionReport) {
									const reportPanels = report?.panels.reduce<string[]>((acc, p) => {
										const v = valueToString(p.value);
										if (v !== undefined) {
											acc.push(v);
										}
										return acc;
									}, []) ?? [];
									importGoals(
										data.id,
										alert,
										reportPanels,
										setLoadingState, () => {
											fetchGoals();
											setLoadingState(LoadingStateEnum.LOADED);
										},
										data.value.evolution as Granularity
									);
								}
								else if (value.value === 8) {
									setIsCreateChartPopupOpen(true);
								}
							}}
						/>
					</>}
			</>

		});

	}, [props.state.data?.id, loadingState, subComponentToolBarVersion, user, finalyFilteredProducts, views, filterParams, filters.filter, allBrands, name, isDateFuckedUp, props.state.data, JSON.stringify(filters), props.state.data.id, isGoals]);

	function DuplicateReport(props: { oldReport: any, onBreak: () => void, onOk: () => void, categoryId?: number }) {
		const [name, setName] = React.useState<string>('');
		const history = useHistory();
		return <>
			<Input name='' value={name} type='text' onChange={setName} label={translateToString('name')} />
			<DefaultButton
				margin='0'
				onClick={() => {
					props.onOk();
					createGenericReport({ 'name': name, 'value': props.oldReport.value, 'report_group_id': props.categoryId ?? 0 }).then(res => {
						getGenericReport(res).then(report => {
							setLocalReport({
								id: report.id,
								name: report.name,
								report: report.value
							});
							history.push({ pathname: 'reportEditor' });
						});
					}
					);
				}}
				disabled={!name}>
				<Translate id='next' />
			</DefaultButton>
		</>;
	}


	function convertGranularity(g: Granularity): ValidatorGranularity {
		switch (g) {
			case 'day':
				return wasm.Granularity.Day;
			case 'week':
				return wasm.Granularity.Week;
			case 'month':
				return wasm.Granularity.Month;
			case 'quarter':
				return wasm.Granularity.Quarter;
			case 'year':
				return wasm.Granularity.Year;
			case 'fourMonths':
				return wasm.Granularity.FourMonths;

		}
	}

	// the one resolved request body: the display query, the server export and
	// the lazy subtree loads must send the exact same thing — row ids are
	// deterministic per body, and a drift would make expansion load the wrong
	// node's children
	const buildQueryBody = (): GenericReport | undefined => {
		if (!pickedDates?.[0] || !pickedDates[1]) return undefined;
		return {
			...props.reprasentation,
			...filters,
			range: { begin: momentToNaiveDateTime(pickedDates[0]), end: momentToNaiveDateTime(pickedDates[1]) },
			product_filter: getFinalyFilteredProducts(filters, products, productFieldValues),
			filter: filters.filter?.formatted,
			window: filters.my_filters && filters.my_filters.timerange && (props.reprasentation.variation || props.reprasentation.evolution || !props.reprasentation.sum || isExternalGenericReport(props.reprasentation)) && filters.my_filters.timerange != 'thisperiod' ? dateToNaiveDateTime(TimeRange3ToDate(filters.my_filters.timerange, pickedDates[0].toDate())!) : undefined
		};
	};

	React.useEffect(() => {
		// the product field filters wait for their values
		if (!loadingState && (pickedDates != null) && pickedDates[0] && pickedDates[1] && productFieldValues) {
			if (props.reprasentation.evolution && !wasm.validate_granularity(pickedDates[0].toDate(), pickedDates[1].toDate(), convertGranularity(granularity))) {
				setLoadingState(LoadingStateEnum.ERROR);
			} else try {
				setLoadingState(LoadingStateEnum.LOADING);
				if (props.state.data?.value.cancelTokenSource) {
					props.state.data?.value.cancelTokenSource.cancel();
				}
				const cancelTokenSource = axios.CancelToken.source();
				props.dispatch({ type: 'SET_CANCEL_TOKEN_SOURCE', value: cancelTokenSource });
				props.dispatch({ type: 'SET_IS_LOADING', value: true });
				const bdy = buildQueryBody()!;
				getGenericAndDecodeReport(bdy, undefined).then(report => {
					setReport(report);
					setReportGeneration(g => g + 1);
					if (loadingState != LoadingStateEnum.LOADED) {
						setLoadingState(LoadingStateEnum.LOADED);
					}
					props.dispatch({ type: 'SET_IS_LOADING', value: false });
				})
					.catch(e => {
						if (axios.isCancel(e)) {
							console.error('Canceling job in: OrderPerProductPerCompany ', e);
						} else {
							console.error(e);
							props.dispatch({ type: 'SET_IS_LOADING', value: false });
						}
						// the server refuses over-sized reports with an actionable
						// plain-text reason (row count, what to narrow): show it
						// instead of the generic loading error. The body arrives
						// as an ArrayBuffer because the query asks for one.
						try {
							const data = e?.response?.data;
							const text = data instanceof ArrayBuffer ? new TextDecoder().decode(data) : typeof data === 'string' ? data : undefined;
							setErrorMessage(e?.response?.status === 400 && text ? text : undefined);
						} catch {
							setErrorMessage(undefined);
						}
						setLoadingState(LoadingStateEnum.ERROR);
					});
			} catch (e) {
				console.error(e);
				setLoadingState(LoadingStateEnum.ERROR);
			}
		}
	}, [selectedView, props.state.data.id, props.state, loadingState, pickedDates, JSON.stringify(props.reprasentation), user, finalyFilteredProducts.value, finalyFilteredProducts.setted, variation, formTemplateTemplate, tagsFilter, pickedRange, pickedDates, JSON.stringify(filters.my_filters), productFieldValues]);

	const visualizationFilterParams: FilterParameter[] = React.useMemo(() => {
		const filters: Filter[] = initFilters(props.reprasentation).right_jsx.map(e => {
			return {
				id: e.name,
				name: e.name,
				type: 'nullable',
				jsx: e.child,
				isFilterSet: checkFilterSet(e.name, e.child)
			};
		});

		if (!props.reprasentation.evolution && props.reprasentation.sum) {
			filters.splice(0, 1);
		}

		// un rapport externe ventilé garde la fenêtre: avec le glissement elle
		// devient la fenêtre glissante de chaque période (CAD/CAM)
		else if (props.reprasentation.evolution && !isExternalGenericReport(props.reprasentation)) {
			filters.splice(1, 1);
		}

		return [{
			filters,
			category: translateToString('settings'),
		}];
	}, [props.reprasentation.evolution, props.reprasentation.sum, report]);

	if (loadingState === LoadingStateEnum.ERROR) {
		return <NoData message={errorMessage ?? translateToString('reports.loading_error')} isError={true} height='calc(100% - 10px)'></NoData>;
	}

	if (!report) return <ComponentLoader loadingState={loadingState} allScreen />;

	return <>
		<Popup
			isOpen={isCreateChartPopupOpen}
			popupMode={PopupMode.Default}
			onClickOut={() => setIsCreateChartPopupOpen(false)}
		>
			{isCreateChartPopupOpen && report && props.state.data?.id != null &&
				<CreateChartPopup
					dashboards={dashboards}
					onClose={() => setIsCreateChartPopupOpen(false)}
					onSubmit={() => {
						setIsCreateChartPopupOpen(false);
						launchToast(translateToString('dashboard.create_chart_from_report_success'), 5000);
					}}
					computedReport={{ ...report, name: reportInfos?.name ?? '', report_id: props.state.data.id }}
				/>
			}
		</Popup>
		<ReportInterpretorNoProvider
			key={`${props.state.selectedReport}-${reportGeneration}`}
			onLoadSubtree={async(panel, path) => {
				const body = buildQueryBody();
				if (!body) return;
				try {
					const res = await getGenericAndDecodeReport({ ...body, subtree_of: { panel, path } }, undefined);
					const children = res.panels[0]?.rows;
					// a node only carries a sentinel when it had children at
					// build time: an empty answer means the displayed ids no
					// longer match the server's build
					if (!children || children.length === 0) throw new Error('stale report node');
					setReport(prev => {
						if (!prev || !prev.panels[panel]) return prev;
						let level: Row[] = prev.panels[panel].rows;
						for (let i = 0; i < path.length - 1; i++) {
							const row = level.find(r => r.id === path[i]);
							if (!row) return prev;
							level = row.rows;
						}
						const target = level.find(r => r.id === path[path.length - 1]);
						if (!target) return prev;
						target.rows = children;
						// new identities down to the panel so the memoized
						// table data recomputes
						const panels = [...prev.panels];
						panels[panel] = { ...prev.panels[panel] };
						return { ...prev, panels };
					});
				} catch (e) {
					// the displayed report no longer matches the server (a
					// cached response whose data moved since): reload fresh,
					// bypassing the response cache — the remount collapses the
					// tree with ids the next expansions can trust
					console.error('lazy subtree load failed, reloading the report', e);
					const fresh = await getGenericAndDecodeReport(body, undefined, true).catch(() => undefined);
					if (!fresh) return;
					setReport(fresh);
					setReportGeneration(g => g + 1);
					launchToast(translateToString('reports.reloaded_stale'), 5000);
				}
			}}
			setToolBarState={setSubComponentToolBarState}
			externalActiveFilter={[tagsFilter && tagsFilter?.length > 0, !allBrands, !user?.[2], filteredProducts && !filteredProducts?.all].reduce((acc, t) => t ? acc + 1 : acc, 0)}
			filterResult={filters.filter}
			report={report}
			reportId={props.state.data.id}
			height={height - TOOLBARS_HEIGHT - 98}
			filterParams={filterParams}
			visualizationFitlerParams={visualizationFilterParams}
			onFiltersChange={result => setFilters(f => ({ ...f, filter: result }))}
			reprasentation={props.reprasentation}
			context
			onStoreColumn={async(columnIndex, panelIndex, columnName) => {
				const newReport = props.state.data;
				if (!newReport) return;
				const newColumnId = await createNewAdditionalColumn(columnName);
				const key = Object.keys(newReport.value.panels[panelIndex].columns[columnIndex])[0];
				newReport.value.panels[panelIndex].columns[columnIndex][key].additional_column = newColumnId;
				// only the definition: the row's goals options are not in the
				// updated-field form the update expects
				await updateGenericReport(props.state.data.id, { value: newReport.value });
				await props.updateGenericReports();
				refresh();
			}}
			onUnstoreColumn={async(columnIndex) => {
				await syncTagsAndStatuses({
					tags: [], statuses: [], field_type: TagType.COMPANY, additional_columns: [
						{ Deletion: columnIndex }
					], additional_field_columns: []
				});
				await props.updateGenericReports();
				refresh();
			}}
			onCreateCalcField={async(columnIndex, panelIndex, columnName) => {
				const report = _.cloneDeep(props.reprasentation);
				const finalyFilteredProducts = getFinalyFilteredProducts(filters, products, productFieldValues);
				if (pickedDates === undefined || pickedDates[0] === undefined || pickedDates[1] === undefined)
					return;
				const picked = report.panels[0].columns[columnIndex];
				// une colonne externe (ClickHouse) s'épingle en champ calculé
				// externe: le worker somme la mesure sur une fenêtre glissante
				// de la durée du rapport
				if (picked && typeof picked === 'object' && 'External' in picked) {
					const external = (picked as unknown as { External: { dataset: string, measure: string } }).External;
					const datasets: { dataset: string, measures: { slug: string, value_type: string }[] }[] = await getExternalDatasets().catch(() => []);
					const valueType = datasets.find(d => d.dataset === external.dataset)?.measures.find(m => m.slug === external.measure)?.value_type;
					// une ligne produit dans le rapport épinglé donne un KPI
					// externe par produit (Value::Products par société)
					const perProduct = report.panels[0].columns
						.slice(0, report.new_group_by ?? 0)
						.some(c => c && typeof c === 'object' && ('ProductColumn' in c || 'ExternalDimension' in c));
					const calcField: PostCalculatedField = {
						report: {
							external: {
								dataset: external.dataset,
								measure: external.measure,
								window_weeks: Math.max(1, Math.round(pickedDates[1].diff(pickedDates[0], 'weeks', true))),
								vs_n1: (props.reprasentation.variation as unknown) === 'N1',
								minor_units: valueType === 'money',
								per_product: perProduct,
							},
						} as unknown as GenericReport,
						field_name: columnName,
						target: CalculatedFieldTarget.External,
						ishidded: false,
						// the column's colours come along
						display_options: columnDisplayOptionsOf(props.reprasentation, picked),
					};
					postCalculatedFields(calcField).then(id => { setCalcFieldAtom([...calculatedFields, { ...calcField, id }]); });
					return;
				}
				report.range = { begin: momentToNaiveDateTime(pickedDates[0]), end: momentToNaiveDateTime(pickedDates[1]) };
				if (finalyFilteredProducts !== undefined && finalyFilteredProducts.length > 0) {
					report.product_filter = finalyFilteredProducts;
				}
				report.variation = null;
				report.evolution = null;
				// the report's company filter (promotions included) stays in the
				// definition as its bare tree: the recompute worker honors it
				report.filter = (filters.filter?.formatted ?? null) as unknown as typeof report.filter;
				report.window = null;
				// les lignes de regroupement restent dans la définition: le
				// backend les retire et bascule la cible en company_product
				// quand un produit y figure
				const lines = report.panels[0].columns.slice(0, report.new_group_by ?? 0);
				report.panels[0].columns = [...lines, picked];
				if (report.panels[0].products !== undefined) {
					if (panelIndex !== 0 && report.panels[0].products.length > panelIndex - 1) {
						const productPannel = products.find(product => product.uuid === report.panels[0].products![panelIndex - 1]);
						if (productPannel === undefined) return;
						report.my_filters = { ...report.my_filters, products: { all: false, products: [productPannel.id] } };
						report.product_filter = [productPannel.uuid];
					}
					delete report.panels[0].products;
				}
				const calcField: PostCalculatedField = {
					report: report,
					field_name: columnName,
					target: CalculatedFieldTarget.Company,
					ishidded: false,
					display_options: columnDisplayOptionsOf(props.reprasentation, picked),
				};
				postCalculatedFields(calcField).then(id => { setCalcFieldAtom([...calculatedFields, { ...calcField, id }]); });
			}}
			goalsProps={{
				reportId: props.state.data.id,
				isGoals: isGoals,
				setIsGoals: setIsGoals,
				goals: goals,
				isEvolutionsReport: isEvolutionReport ?? false,
				emptyGoalInterpretation: emptyGoalInterpretation,
				setEmptyGoalInterpretation: setEmptyGoalInterpretation,
				evolutionCalculus: evolutionCalculus,
				setEvolutionCalculus: setEvolutionCalculus,
				setGoalHashMap: setGoalHashMap,
				setSelectedPanel: setSelectedPanel,
				showDelta: showDelta,
				setShowDelta: setShowDelta,
				weightByRef: weightByRef,
				setWeightByRef: setWeightByRef,
				hasPercentages: hasPercentages
			}}
		/>
		<ComponentLoader loadingState={loadingState} allScreen />
		<PopupDeletion
			records={1}
			translationKey='view'
			noVerification
			isOpen={deletionModalState.isOpen}
			onClickOut={() => setDeletionModalState({ isOpen: false })}
			onValidation={() => {
				if (deletionModalState.data) {
					deleteView(deletionModalState.data.id).then(_ => getViews().then(setViews));
				}
			}}
		/>
		<PopupView
			isOpen={isViewOpen}
			view={editedView ?? selectedView}
			onClickOut={() => { setIsViewOpen(false); setEditedView(undefined); }}
			onValidation={v => {
				saveView(v).then(_ => setIsViewOpen(false));
				setEditedView(undefined);
			}} />
		<PopupExportReport
			isOpen={isReportExportOpen}
			setIsReportExportOpen={setIsReportExportOpen}
			onServerExport={async includeNodes => {
				const body = buildQueryBody();
				if (!body) return;
				// the same resolved body the query uses; the server rebuilds the
				// report and delivers the workbook through the export toast
				reduxDispatch({ type: 'INSERT_MESSAGE', value: { message: { text: 'exports.ready_toast' }, state: 'loading' } });
				// the toast stays for the whole run and links to the downloads
				// page; the completion websocket message flips it
				launchExportRunningToast();
				try {
					await exportGenericReportServer(body, includeNodes, props.state.data.name ?? 'report');
				} catch (e) {
					// a refused request would otherwise leave the loading toast
					// hanging forever
					console.error('server export failed', e);
					failExportRunningToast();
					reduxDispatch({ type: 'INSERT_MESSAGE', value: { message: { text: 'import.export_error_message', replace_loading: true }, state: 'error' } });
				}
			}}
			report={report}
			products={products}
			owners={owners}
			evolutionStateRef={evolutionStateRef}
			companies={companies}
			campaigns={campaigns}
			stateData={props.state.data}
			goalHashMap={goalHashMap}
			isGoals={isGoals}
			selectedPanel={selectedPanel}
			warning={isGoals && report.panels.length > 1 ? translateToString('reports.export_report_goals_warning') : undefined}
		/>
	</>;
}
